import React from 'react';
import { useSelector } from 'react-redux';
import ShoppingBasket from '../../order/shoppingbasket';
import {
    removeOrder,
    sendOrders,
    sendOrdersCombined,
    autosaveOrder,
    saveOrderToStore,
} from '../../modules/customerorderdata';
import { getLocationFull } from '../../modules/customerlocationdata';
import useOrderAutosave from '../../order/useOrderAutosave';

const actions = { removeOrder, sendOrders, sendOrdersCombined, saveOrderToStore, autosaveOrder, getLocationFull };
const selectOrderState = (state) => state.customerorderdata;

export default function CustomerShoppingBasketContainer(props) {
    const {
        pendingOrders,
        sendingOrdersInProgress,
        orderSendFailed,
        savingCombinedOrder,
        autosaving,
        autosavingFailed,
        unsavedChanges,
        orderChanged,
        removeOrder: removeOrderInt,
        sendOrders: sendOrdersInt,
        sendOrdersCombined: sendOrdersCombinedInt,
        getLocationFull: getLocationFullInt,
    } = useOrderAutosave({ selectOrderState, actions, retryTimeout: 3000 });

    const locationsById = useSelector((state) => state.locationdata.locationsById);
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const parameters = useSelector((state) => state.parameterdata.parameters);

    return (
        <ShoppingBasket
            customerView={true}
            pendingOrders={pendingOrders}
            sendingOrdersInProgress={sendingOrdersInProgress}
            orderSendFailed={orderSendFailed}
            locationsById={locationsById}
            removeOrder={removeOrderInt}
            sendOrders={sendOrdersInt}
            sendOrdersCombined={sendOrdersCombinedInt}
            getLocationFull={getLocationFullInt}
            userProfile={userProfile}
            savingCombinedOrder={savingCombinedOrder}
            parameters={parameters}
            orderChanged={orderChanged}
            autosaving={autosaving}
            autosavingFailed={autosavingFailed}
            unsavedChanges={unsavedChanges}
        />
    );
}
